import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import { makeStyles } from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { StyledCheckbox } from '../../common/models/CheckBox';

const useStyles = makeStyles((theme) => ({
  root: {
    justify: 'flex-start',
    backgroundColor: '#F2F2F2',
    border: '2px solid #E2E2E2',
    maxHeight: '22rem',
    overflow: 'scroll',
    padding: '1rem',
  },
  text: {
    marginBottom: '0.9rem',
    fontSize: '0.8rem',
  },
  bottomgrid: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-around',
    marginBottom: '2rem',
    marginTop: '1rem',
  },
}));

const ConsentAgreement = (props) => {
  const { handleConsent, consent1, consent2, errors } = props;

  const classes = useStyles();

  return (
    <Grid container justify='center'>
      <Typography
        variant='h6'
        style={{ fontSize: '1rem', padding: '0.75rem 0' }}
      >
        Collabrix Inc. Application and Services Terms &amp; Conditions
      </Typography>

      <Grid item xs={11} sm={11} md={11}>
        {/* Maintain a class for this box and for small screens increase size -media query*/}
        <Box className={classes.root}>
          <Typography variant='body1' className={classes.text}>
          <strong>Effective Date: Oct 1, 2025</strong> <br />
         <br />
          Welcome to Mosymphony, a cloud-based collaboration platform offered by Collabrix Inc., headquartered in Texas,
          USA <strong>(“Collabrix Inc.”, “we”, “us”,</strong> or <strong>“our”)</strong>.
          These Terms of Use <strong>(“Terms”)</strong> govern your organization’s access to and use of Mosymphony and its associated services 
          (the <strong>“Service”</strong>).<br />
          <br />
          Mysymphony is an enterprise-grade, blockchain-powered, cloud-hosted <strong>Software-as-a-Service
          (SaaS)</strong> designed specifically to serve life sciences organizations. It digitizes and standardizes supply
          chain processes to improve procurement efficiency, enhance data integrity, and increase operational
          yields across contract manufacturing networks.<br />
          <br />
          By accessing or using the Service on behalf of your organization, you <strong>(“Customer”, “you”,</strong> or <strong>“your”)</strong>
          confirm that you are authorized to bind such organization to these Terms and agree to comply with them.
          <strong>IF YOU DO NOT AGREE TO THESE TERMS, DO NOT ACCESS OR USE THE PLATFORM.</strong>
          </Typography>

          <Typography variant='body1' className={classes.text}>
          <strong>1. Acceptance of Terms</strong>
          </Typography>

          <Typography variant='body1' className={classes.text}>
          These Terms apply to your organization’s use of the Service.
          Continued access and use constitute acceptance. If your organization does not agree to these Terms,
          it must discontinue all use of the Service. We may update these Terms at any time, for any reason, 
          at our sole discretion. When changes are made, we will revise the “Last Updated” date. 
          Continued use of the Services after such updates constitutes acceptance of the revised Terms.
          It is your responsibility to periodically review the Terms to remain informed. 
          This Platform is not intended for distribution or use in any jurisdiction or country where such use 
          would violate laws or require additional compliance measures. Users accessing the Platform from outside
          the United States, United Kingdom, Asia including India shall do so at their own risk and are responsible 
          for compliance with local laws. The Service is not intended for use in connection with industry-specific data 
          regulations such as Health Insurance Portability and Accountability Act (1996) (“HIPAA”), Federal Information Security
          Management Act (2002) (“FISMA”), or Gramm-Leach-Bliley Act (1999) (“GLBA”). If your organization is subject to such regulations, 
          you are responsible for determining whether Mosymphony is appropriate for your use.
          </Typography>

          <Typography variant='body1' className={classes.text}>
          <strong>2. Eligibility</strong>
          </Typography>

          <Typography variant='body1' className={classes.text}>
          To use the Service, you represent and warrant that:
          <ul>
            <li>You are authorized to act on behalf of your subscribing organization;</li>
            <li>The organization has entered into a valid Subscription Agreement with Collabrix Inc.;</li>
            <li>Use of the Service complies with all applicable local, national, and international laws, including data protection and export control requirements.</li>
          </ul>
          </Typography>

          <Typography variant='body1' className={classes.text}>
            <strong>3. Account Registration and Access</strong>
          </Typography>

          <Typography variant='body1' className={classes.text}>
          <ul>
            <li>Use of the Service requires registration of an organizational account.</li>
            <li>Your organization is responsible for managing access credentials and user roles.</li>
            <li>You must promptly notify Collabrix Inc. of any unauthorized access or security incidents related to the Service.</li>
          </ul>
          </Typography>

          <Typography variant='body1' className={classes.text}>
            <strong>4. License and Permitted Use</strong>
          </Typography>

          <Typography variant='body1' className={classes.text}>
          All components of the Service including but not limited to code, design, architecture, data models,
           analytics logic, user interfaces, digital assets,
           and documentation (collectively, the <strong>“Content”</strong>) and all associated trademarks,
           service marks, and branding (the “Marks”) are the intellectual property of Collabrix Inc. or its licensors. 
           Collabrix Inc. grants your organization a <strong>limited, non-exclusive, non-transferable, revocable license</strong> to access and use the Service strictly for its internal business operations and subject to these Terms and the Subscription Agreement.
          You and your organisation shall not:
          <ul>
            <li>Copy, modify, decompile, or reverse engineer any part of the Service;</li>
            <li>Circumvent security measures or impair Service functionality;</li>
            <li>Use the Service to process unlawful, infringing, or unauthorized content;</li>
            <li>Permit third parties outside your organization to use the Service unless explicitly authorized in writing.</li>
            <li>Reproduce, distribute, sublicense, reverse engineer, or create derivative works from any part of the Service;</li>
            <li>Remove, obscure, or modify any copyright, trademark, or proprietary notices;</li>
            <li>Use the Content or Marks for commercial exploitation outside of authorized SaaS usage.</li>
          </ul> <br />
        
          Violations of the above may result in immediate termination of access and potential legal action.
 Third-party code, APIs, or connectors referenced or linked within the Services are governed by their respective licensors and not by Collabrix Inc.
          </Typography>

          <Typography variant='body1' className={classes.text}>
            <strong>5. Subscription Agreement</strong>
          </Typography>

          <Typography variant='body1' className={classes.text}>
          Use of the Service is governed by a <strong>master Subscription Agreement or End User License Agreement</strong> between your organization and Collabrix Inc.
          This agreement outlines service entitlements, SLAs, pricing, and data handling obligations.
          In the event of any conflict between these Terms and the Subscription Agreement, the Subscription Agreement shall control.
          Third-party code, APIs, or connectors referenced or linked within the Services are governed by their respective licensors and not by Collabrix Inc.
          </Typography>

          <Typography variant='body1' className={classes.text}>
            <strong>6. User Data and User Generated Content</strong>
          </Typography>

          <Typography variant='body1' className={classes.text}>
          <ul>
            <li>Your organization retains all rights to the data it submits to the Service <strong>(“Customer Data”)</strong>.</li>
            <li>Collabrix Inc. processes Customer Data solely in accordance with its Privacy Policy and any applicable <strong>Data Processing Agreement (DPA)</strong>.</li>
            <li>You agree not to submit <strong>Personal Health Information (PHI)</strong> or data subject to heightened regulatory protection unless authorized under a separate written agreement with Collabrix Inc.</li>
            <li>By using the Service, you agree to our Privacy Policy, which is incorporated herein. The Service is hosted in the U.S., and by accessing it, you consent to the processing and transfer of your data to the United States.</li>
            <li>User Generated Contribution- The Service may offer you and your organization opportunities to engage in chats, that allow you and your organization to create, post, display, publish, or transmit content including but not limited to text, (“Contributions”). You and your organization represent and warrant that the Contributions shall not be obscene, offensive, or harmful to any person or entity, do not promote violence, harm, or hate speech, shall not be unlawful and shall always comply with applicable laws. 
            Any breach of this representation and/or warranty may result in termination or suspension of Your rights to use the Platform.</li>
          </ul>
          </Typography>

          <Typography variant='body1' className={classes.text}>
            <strong>7. Data Hosting and Compliance</strong>
          </Typography>

          <Typography variant='body1' className={classes.text}>
          <ul>
            <li>Customer Data may be hosted in the United States, European Union, India, or other permitted jurisdictions, based on your data residency configuration.</li>
            <li>Collabrix Inc. complies with relevant regulatory standards such as <strong>GDPR, 21 CFR Part 11</strong>, and <strong>applicable export controls</strong>.</li>
            <li>Your organization remains responsible for determining whether its use of the Service satisfies jurisdiction-specific regulatory or legal requirements.</li>
          </ul>
          </Typography>
          <Typography variant='body1' className={classes.text}>
            <strong>8. Intellectual Property</strong>
          </Typography>

          <Typography variant='body1' className={classes.text}>
          <ul>
            <li>All intellectual property rights in the Service (including software, documentation, and branding) are owned by or licensed to Collabrix Inc.</li>
            <li>No rights, title, or interest are transferred to your or your organization, except the limited rights expressly granted herein.</li>
          </ul>
          </Typography>

          <Typography variant='body1' className={classes.text}>
            <strong>9. Third-Party Services</strong>
          </Typography>

          <Typography variant='body1' className={classes.text}>
          <ul>
            <li>The Service may integrate with third-party applications (e.g., ERP, QMS, and LIMS) at your organization’s request.
            </li>
            <li>Use of third-party services is governed by the respective provider’s terms. Collabrix Inc. disclaims liability arising from third-party integrations.</li>
            <li>Third party links or content provided on the Services do not imply control or endorsement by Collabrix Inc. We are not responsible for the content or practices of third-party websites and recommend reviewing their privacy policies and terms of use separately.</li>
          </ul>
          </Typography>

          <Typography variant='body1' className={classes.text}>
            <strong>10. Service Availability, Support and Service Management</strong>
          </Typography>

          <Typography variant='body1' className={classes.text}>
          <ul>
            <li>The Service is provided <strong>“as is”</strong> and <strong>“as available”</strong>, unless otherwise stipulated in your Subscription Agreement.
            </li>
            <li>Service support levels, uptime guarantees, and incident response timelines are governed by the Subscription Agreement.</li>
            <li>While we aim to achieve availability of the Service with 99.9% availability, however we may experience hardware, software, 
              or other problems or need to perform maintenance related to the Platform, resulting in interruptions, delays, or errors.
               We reserve the right to change, revise, update, suspend, discontinue, or otherwise modify the Service at any time or for any reason without notice to you. 
               You agree that we have no liability whatsoever for any loss, damage, or inconvenience caused by your inability to access or use the Service during any downtime or discontinuance of the Service.
              Nothing in these Terms of Use will be construed to obligate us to maintain and support the Service or to supply any corrections, updates, or releases in connection therewith.</li>
              <li>We reserve the right to change, modify, or remove the contents of the Service at any time or for any reason at our sole discretion with prior notice.
                 However, we have no obligation to update any information on the Service. We also reserve the right to modify or discontinue all or part of the Service without notice at any time. 
                We will not be liable to you or any third party for any modification,
                price change, suspension, or discontinuance of the Service.</li>
          </ul>
          </Typography>

          <Typography variant='body1' className={classes.text}>
            <strong>11. User Representations</strong>
          </Typography>

          <Typography variant='body1' className={classes.text}>
          By accessing or using the Service, you and your organisation represent and warrant that:
          <ul>
            <li>You have full legal authority to enter into these Terms on behalf of yourself or your organization.
            </li>
            <li>You are at least 18 years old.</li>
            <li>You and your organisation will not use automated tools (bots, crawlers, etc.) to access the Service.</li>
              <li>Your use of the Service complies with all applicable laws and regulations.</li>
              <li>You will not tamper with, reverse engineer, or compromise the Service or related systems.</li>
              <li>We reserve the right to suspend or terminate your organisational account if any representation is found to be untrue or if misuse is detected.</li>
              <li>You agree to treat all non-public information exchanged under these Terms as confidential, including Customer Data and technical details of the Service.</li>
              <li>You and your organisation agree not to misuse the Service or engage in any of the following activities:
                <ul>
                  <li>Unauthorized data scraping or content harvesting</li>
                  <li>Automated account creation or impersonation</li>
                  <li>Circumventing access controls or security mechanisms
                  </li>
                  <li>Hosting or spreading malware or harmful code</li>
                  <li>Interfering with Service performance or availability</li>
                  <li>Commercial use or resale without authorization</li>
                  <li>Reverse engineering or exploiting platform architecture
                  </li>
                  <li>Uploading offensive, abusive, or misleading content</li>
                  <li>Harassing our team or other users
                  </li>
                  <li>Violating applicable laws or third-party rights</li>
                  <li>Any such behavior may result in account suspension, legal action, or permanent termination of access.</li>
                </ul>
              </li>
          </ul>
          </Typography>
          <Typography variant='body1' className={classes.text}>
            <strong>12. Termination</strong>
          </Typography>

          <Typography variant='body1' className={classes.text}>
          <ul>
            <li>The Terms remain in effect while you use the Service.
            </li>
            <li>Either party may terminate access to the Service as defined in the Subscription Agreement.</li>
            <li>Upon termination, all access credentials will be disabled. Collabrix Inc. will retain or delete Customer Data in accordance with its data retention policy, applicable laws, and any specific contractual provisions.</li>
            <li>We reserve our right to terminate or suspend access without notice for any breach.
            </li>
          </ul>
          </Typography>

          <Typography variant='body1' className={classes.text}>
            <strong>13. Indemnification</strong>
          </Typography>

          <Typography variant='body1' className={classes.text}>
          Your organization agrees to indemnify, and hold harmless, Collabrix Inc., including our subsidiaries, affiliates, and all of our respective officers,
           agents, partners, and employees, from and against any loss, damage, liability, claim, or demand, including reasonable
            attorneys’ fees and expenses, made by any third party due to or arising out of: (1) your Contributions; (2) use of the
             Service; (3) breach of these Terms of Use; (4) any breach of your representations and warranties set forth in these 
             Terms of Use; (5) your violation of the rights of a third party, including but not limited to intellectual property 
             rights; or (6) any overt harmful act toward any other user of the Service with whom you connected via the Service.
              Notwithstanding the foregoing, we reserve the right, at your expense, to assume the exclusive defense and control of 
              any matter for which you are required to indemnify us, and you agree to cooperate, at your expense, with our defense of such claims.
               We will use reasonable efforts to notify you of any such claim, action, or proceeding which is subject to this indemnification upon becoming aware of it.

          </Typography>

          <Typography variant='body1' className={classes.text}>
            <strong>14. Disclaimer of Warranties</strong>
          </Typography>

          <Typography variant='body1' className={classes.text}>
          Unless otherwise provided in your Subscription Agreement:
          <ul>
            <li>The Service is provided without warranties of any kind, whether express or implied.
            </li>
            <li>All implied warranties, including merchantability and fitness for a particular purpose, are expressly disclaimed.</li>
          </ul>
          </Typography>

          <Typography variant='body1' className={classes.text}>
            <strong>15. Limitation of Liability</strong>
          </Typography>

          <Typography variant='body1' className={classes.text}>
          To the maximum extent permitted by law:
          <ul>
            <li>Collabrix Inc. shall not be liable for any indirect, incidental, consequential, or special damages, even if advised of the possibility;
            </li>
            <li>Total liability under these Terms shall not exceed the fees paid by your organization to Collabrix Inc. in the twelve (12) months preceding the claim.</li>
          </ul>
          </Typography>

          <Typography variant='body1' className={classes.text}>
            <strong>16. Modifications to Terms</strong>
          </Typography>

          <Typography variant='body1' className={classes.text}>
          Collabrix Inc. may modify these Terms from time to time. Material changes will be communicated via email or in-product notifications. 
          Continued use of the Service following such changes constitutes acceptance.
          </Typography>

          <Typography variant='body1' className={classes.text}>
            <strong>17. Export Compliance</strong>
          </Typography>

          <Typography variant='body1' className={classes.text}>
          Your organization agrees to comply with all applicable export and re-export control laws, including 
          those of the <strong>United States</strong> and the <strong>European Union</strong>, in connection with its use of the Service.
          </Typography>

          <Typography variant='body1' className={classes.text}>
            <strong>18. Governing Law and Dispute Resolution</strong>
          </Typography>

          <Typography variant='body1' className={classes.text}>
          These Terms are governed by the laws of the <strong>State of Texas</strong>, without regard to conflict of law rules.
           All disputes will be resolved in the <strong>state or federal courts located in Texas</strong>, unless otherwise agreed in writing.
          </Typography>

          <Typography variant='body1' className={classes.text}>
            <strong>19. Entire Agreement</strong>
          </Typography>

          <Typography variant='body1' className={classes.text}>
          These Terms, together with the applicable <strong>Subscription Agreement</strong> and any active <strong>Data Processing Agreement</strong>, 
          constitute the complete agreement between the parties regarding use of the Service.
          </Typography>

          <Typography variant='body1' className={classes.text}>
            <strong>20. Miscellaneous</strong>
          </Typography>

          <Typography variant='body1' className={classes.text}>
          These Terms of Use and any policies or operating rules posted by us on the Service or in respect to the Service constitute the entire agreement 
          and understanding between you and us. Our failure to exercise or enforce any right or provision of these Terms of Use shall not operate as a waiver
           of such right or provision. These Terms of Use operate to the fullest extent permissible by law. We may assign any or all of our rights and obligations 
           to others at any time. We shall not be responsible or liable for any loss, damage, delay, or failure to act caused by any cause beyond our reasonable control.
            If any provision or part of a provision of these Terms of Use is determined to be unlawful, void, or unenforceable, that provision or part of the provision is
             deemed severable from these Terms of Use and does not affect the validity and enforceability of any remaining provisions. There is no joint venture, partnership,
              employment or agency relationship created between you and us as a result of these Terms of Use or use of the Service. You agree that these Terms of Use will not be
               construed against us by virtue of having drafted them. You hereby waive any and all defenses you may have based on the electronic form of these Terms of Use and the lack of 
               signing by the parties hereto to execute these Terms of Use.
          </Typography>

          <Typography variant='body1' className={classes.text}>
            <strong>21. Contact Information</strong>
          </Typography>

          <Typography variant='body1' className={classes.text}>
          For questions about these Terms, contact:<br />
          <strong>Collabrix Inc.</strong><br />
          12777 Jones Road, Suite 445<br />
          Houston, Texas 77070, USA<br />
          Email: hello@collabrix.co
          </Typography>

        </Box>
      </Grid>
      {/** Show consent error */}
      {errors.consent && (
        <Grid item xs={11} style={{ marginTop: '1rem' }}>
          <Typography
            variant='body1'
            style={{
              border: '1px solid #FF0000',
              backgroundColor: '#FFF0F0',
              opacity: '1',
              textAlign: 'center',
              padding: '0.5rem',
              fontSize: '0.875rem',
            }}
          >
            {errors.consent}
          </Typography>
        </Grid>
      )}
      {/* needs to have checkboxes down */}
      <Grid
        item
        xs={11}
        style={{ marginLeft: '0.25rem', paddingTop: '0.75rem' }}
      >
        <FormGroup>
          <FormControlLabel
            control={
              <StyledCheckbox
                name='consent1'
                checked={consent1}
                onChange={handleConsent}
              />
            }
            label={
              <Typography variant='caption' style={{ fontSize: '0.75rem' }}>
                I have read and agree to the above terms &amp; conditions for
                application usage
              </Typography>
            }
          />
          <FormControlLabel
            control={
              <StyledCheckbox
                name='consent2'
                checked={consent2}
                onChange={handleConsent}
              />
            }
            label={
              <Typography variant='caption' style={{ fontSize: '0.75rem' }}>
                I accept and agree with the data storage &amp; usage policy
                mentioned above
              </Typography>
            }
          />
        </FormGroup>
      </Grid>
    </Grid>
  );
};

export default ConsentAgreement;
